<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <changeLanguageHeaderTable
      :current-language="currentLanguage"
      @change-language="changeLanguage"
    />

    <BDataTable
      ref="refTable"
      :fetch-list="fetchList"
      :table-columns="tableColumns"
      :create-route="{ name: 'pages-FAQs-add' }"
      @onGroupDelete="groupDelete"
    >
      <!-- Column: category -->
      <template #cell(category)="{ item }">
        {{ item.category ? item.category.title : "" }}
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <edit-row @click.native="toEditPage(item._id)" />
        <delete-row @click.native="deleteItem(item._id)" />
      </template>
    </BDataTable>
  </div>
</template>

<script>
import BDataTable from '@/components/BDataTable/index.vue'
import '@/components/BMediaCustom/index.vue'
import DeleteRow from '@/components/BDataTable/Actions/DeleteRow.vue'
import EditRow from '@/components/BDataTable/Actions/EditRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import '@/components/BDataTable/Elements/TruncateText.vue'
import changeLanguageHeaderTable from '@/components/change-language-header-table.vue'
import useFAQsList from './useFAQsList'

export default {
  name: 'FAQsList',
  components: {
    BDataTable,
    DeleteRow,
    EditRow,
    LayoutLoading,
    changeLanguageHeaderTable,
  },
  setup() {
    const {
      changeLanguage,
      currentLanguage,
      deleteItem,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
    } = useFAQsList()
    return {
      changeLanguage,
      currentLanguage,
      deleteItem,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
    }
  },
}
</script>
